import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import Employees from './pages/Employees';
import FuelRates from './pages/FuelRates';
import DailyAccounting from './pages/DailyAccounting';
import MorningReadings from './pages/MorningReadings';
import PumpConfig from './pages/PumpConfig';
import Reports from './pages/Reports';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="morning-readings" element={<MorningReadings />} />
          <Route path="accounting" element={<DailyAccounting />} />
          <Route path="employees" element={<Employees />} />
          <Route path="rates" element={<FuelRates />} />
          <Route path="pump-config" element={<PumpConfig />} />
          <Route path="reports" element={<Reports />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
